import { ErrorHandler, inject } from '@angular/core';
import { LoggerService } from '../logger';
import { MessageService } from 'primeng/api';

export class AppErrorHandler implements ErrorHandler {
  logger = inject(LoggerService);
  messageService = inject(MessageService);
 
  handleError(error: any): void {
    this.logger.error("AppErrorHandler", error);
    // this.messageService.add({
    //   severity: "error",
    //   summary: "Something went wrong",
    //   key: 'message',
    // })
    // throw error;
    if (
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module")
    ) {
      console.warn("Chunk load failed. Reloading app...");
      window.location.reload();
      return;
    }
  }
}